import __request__ from 'routing/request';
interface CrowdStrikeCreateInputRequest {
    readonly checkpoint_interval_seconds: number;
    readonly name: string;
    readonly crowdstrike_base_url: string;
    readonly crowdstrike_client_id: string;
    readonly store_full_message: boolean;
    readonly enable_throttling: boolean;
    readonly crowdstrike_client_secret: string;
}
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface CrowdStrikeRequestImpl {
    readonly crowdstrike_base_url: string;
    readonly crowdstrike_client_id: string;
    readonly crowdstrike_client_secret: string;
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: CrowdStrikeRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.crowdstrike.api.CrowdStrikeResource/crowdstrike/checkCredentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new CrowdStrike input
 */
export function create(JSONbody: CrowdStrikeCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.crowdstrike.api.CrowdStrikeResource/crowdstrike/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
